module.exports = __webpack_public_path__ + "static/media/EdinburgIL_1-475w.c229b39b.webp";